"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BalanceVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _VariableType = require("../VariableType");
var _VarsValueTypeHandler = require("../../type/VarsValueTypeHandler");
class BalanceVariable extends _VariableType.VarsValueVariableType {
  constructor() {
    super();
    (0, _defineProperty2.default)(this, "settings", BalanceVariable.settings);
    (0, _defineProperty2.default)(this, "type", "balance");
    (0, _defineProperty2.default)(this, "label", "Token Balance");
    (0, _defineProperty2.default)(this, "description", "Load a token balance for a wallet.");
  }
  dependencies(params, resolver) {
    let contract = resolver.resolveContract(params.contract);
    let wallet = resolver.resolveString(params.wallet);
    return {
      contract,
      wallet
    };
  }
  value(deps, batcher) {
    if (!deps) {
      return null;
    }
    let {
      contract,
      wallet
    } = deps;
    if (!contract || !wallet) {
      return null;
    }
    return batcher.batch(contract.network).setContract(contract).addBig("balanceOf", null, [wallet]).execute().then(res => {
      return new _VarsValueTypeHandler.VarsMetaValue(res.balanceOf.div(`1e${contract.parameters.decimals}`).toString(10), "balance", {
        contract
      });
    });
  }
}
exports.BalanceVariable = BalanceVariable;
(0, _defineProperty2.default)(BalanceVariable, "settings", {
  contract: {
    type: "var",
    variableType: "contract",
    description: "Token contract to read balance from."
  },
  wallet: {
    type: "var",
    variableType: ["wallet", "value", "contract"],
    description: "Wallet or contract to read balance for."
  }
});
//# sourceMappingURL=BalanceVariable.js.map